import React from "react";

const FeaturedVideo = () => {
  return (
    <section className="bg-black py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
            <p className="text-xs uppercase tracking-[4px] text-amber-400 font-bold">
              Featured Film
            </p>
            <div className="w-12 h-[2px] bg-gradient-to-l from-amber-400 to-transparent"></div>
          </div>

          <h2 className="text-5xl md:text-6xl font-black text-white">
            Every Moment Deserves a Story
          </h2>
        </div>

        <div className="overflow-hidden">
          <video
            className="h-[650px] w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            controls
          >
            <source src="/videos/wedding.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
  );
};

export default FeaturedVideo;